import Icon from '../../components/Icon.vue'

Icon.register({"brands/yandex-international":{"width":320,"height":512,"paths":[{"d":"M129.5 512V345.9L18.5 48H74.3L156.1 277.7 250.2 0H301.5L180.8 347.8V512H129.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/yandex-international.js
// module id = null
// module chunks = 